module.exports = __webpack_public_path__ + "static/media/chevron-bold.4416bfbc.svg";